import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { SiteConfig, SiteConfigResponse } from '../models/site-config.model';

@Injectable({
    providedIn: 'root'
})
export class SiteConfigService {
    private baseUrl = `${environment.apiUrl}/site-config`;

    constructor(private http: HttpClient) { }

    /**
     * Get site configuration by ID
     * @param configId - The ID of the configuration to retrieve
     * @returns Observable of site configuration response
     */
    getConfig(configId: string): Observable<SiteConfigResponse> {
        return this.http.get<SiteConfigResponse>(`${this.baseUrl}/?companyId=${configId}`);
    }

    /**
     * Update site configuration
     * @param configId - The ID of the configuration to update
     * @param config - The updated configuration data
     * @returns Observable of site configuration response
     */
    updateConfig(configId: string, config: Partial<SiteConfig>): Observable<SiteConfigResponse> {
        return this.http.patch<SiteConfigResponse>(`${this.baseUrl}/${configId}`, config);
    }

    /**
     * Create new site configuration
     * @param config - The configuration data to create
     * @returns Observable of site configuration response
     */
    createConfig(config: SiteConfig): Observable<SiteConfigResponse> {
        return this.http.post<SiteConfigResponse>(this.baseUrl, config);
    }

    /**
     * Delete site configuration
     * @param configId - The ID of the configuration to delete
     * @returns Observable of site configuration response
     */
    deleteConfig(configId: string): Observable<SiteConfigResponse> {
        return this.http.delete<SiteConfigResponse>(`${this.baseUrl}/${configId}`);
    }
}
